export default __webpack_public_path__ + "static/media/uploader.e2acaefe.png";